import { QueryClient, useQuery } from '@tanstack/react-query';

import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';
import { getLayoutPath } from '@telialt/utils/src/getLayoutPath';

import { API } from '../constants/api';
import { FooterDataResponse } from '../model';

const apiGetFooterData = (layoutPath: string) => {
    return axiosForAnonymousHudson.get<FooterDataResponse>(API.FOOTER, {
        params: { path: layoutPath, fieldSet: 'footer' },
    });
};

export const useFooterData = (pathname: string) => {
    const layoutPath = getLayoutPath(pathname);

    return useQuery({
        queryKey: ['FOOTER', pathname],
        queryFn: async () => {
            const { data } = await apiGetFooterData(layoutPath);

            return data;
        },
    });
};

export const prefetchFooterData = (queryClient: QueryClient, pathname: string) => {
    const layoutPath = getLayoutPath(pathname);

    return queryClient.fetchQuery({
        queryKey: ['FOOTER', pathname],
        queryFn: async () => (await apiGetFooterData(layoutPath)).data,
    });
};
